export default [
  {
    id: 0,
    name: "X-Reload",
    description: "Reloading Supplies E-commerce platform built with React and Next.js",
    image: "images/projects/x-reload.jpeg",
    tags: ["typescript", "backend", "html", "css", "next", "mobile"],
    liveview: "https://x-reload.com/",
    github: "https://x-reload.com/",
    alt: "Reloading Supplies E-commerce platform built with React and Next.js",
  },
  {
    id: 1,
    name: "Schoolyard",
    description: "Mobile game app using NFT and Web3 with React Native",
    image: "images/projects/schoolyard.jpeg",
    tags: ["typescript", "mobile", "backend", "nft"],
    liveview: "https://getschoolyard.com/",
    github: "https://getschoolyard.com/",
    alt: "schoolyard mobile app",
  },
  {
    id: 2,
    name: "Apeak Tennis",
    description: "AI-Driven Science-Based Mental Training App",
    image: "images/projects/apeak.png",
    tags: ["typescript", "react", "backend", "mobile", "next"],
    liveview: "https://www.apeak.com/",
    bannerIcons: [
      { src: "images/cssda-icon.png", alt: "cssda High rating on App Store and Google Play Store" },
    ],
    github: "https://github.com/SimpleTire/steer",
    alt: "AI Science-Based Performance",
  },
  {
    id: 3,
    name: "SimpleTire",
    description: "E-Commerce Platform built with React and Next.js",
    image: "images/projects/simpletire.jpg",
    tags: ["typescript", "react", "backend", "mobile", "next"],
    liveview: "https://simpletire.com/",
    github: "https://github.com/SimpleTire/steer",
    alt: "E-Commerce Platform built with React and Next.js",
  },
  {
    id: 4,
    name: "Sorare",
    description: "Compose your lineups, track your teams, claim rewards and more, all in the Sorare app.",
    image: "images/projects/sorare.jpg",
    tags: ["typescript", "mobile", "asp", "react", "nft"],
    liveview: "https://sorare.com/",
    alt: "sorare",
    bannerIcons: [
      { src: "images/cssda-icon.png", alt: "cssda High rating on App Store and Google Play Store" },
    ],
    github: "https://apps.apple.com/us/app/sorare-fantasy-soccer/id1591453776",
  },
  {
    id: 5,
    name: "Modern Apollo",
    description:
      "NFT website built with React and Node.js",
    image: "images/projects/modern.jpg",
    tags: ["react", "typescript", "backend", "mobile", "nft"],
    twitter: "https://modernapollo.club/",
    alt: "modern apollo",
  },
];
